import { render, staticRenderFns } from "./dialogKanBoard.vue?vue&type=template&id=4194a1e2"
import script from "./dialogKanBoard.vue?vue&type=script&lang=js"
export * from "./dialogKanBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports